import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/ppr/my-notification/list';

const PageMyNotificationPprList: React.FC = (props) => {
  const MyNotificationPprList = Loadable.Map({
    loader: {
      page: () => import('./page'),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <MyNotificationPprList {...props} />;
};

export default PageMyNotificationPprList;
